export const dispatchCapacityByEntity = {
    searchText: 'Buscar...',
    export: false,
    checkbox: false,
    disabled: false,
    dialogHability: true,
    filter: false,
    sort: false,
    paginator: true,
    columns: [
      {
        title: "Nombre de capacidad",
        name: "capacityName",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) => element.capacityName,
      },
      {
        title: "Entidades",
        name: "entityNames",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) =>
          element.entityNames ? element.entityNames.join(", ") : "",
      },
      {
        title: "Capacidad genérica",
        name: "genericCapacity",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) => element.genericCapacity,
      },
      {
        title: "Picking feriados",
        name: "pickingHoliday",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) => (element.pickingHoliday ? "SI" : "NO"),
      },
      {
        title: "Tipo de despacho",
        name: "merchandiseType",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) => element.merchandiseType,
      },

      {
        title: "Códigos VTEX",
        name: "vtexCodes",
        type: "string",
        editable: false,
        checkAll: false,
        class: "left",
        value: (element: any) => element.vtexCodes,
      },
    ],
    subTable: {},
  };
  